export const getSections = (lf, panelSize) => {
  if (lf % panelSize === 0) {
    return lf / panelSize;
  } else {
    return Math.ceil(lf / panelSize);
  }
};
